import Chart from 'chart.js'

/**
 * @module
 * @name chartPie
 */
export default {
  name: 'chartPie',
  props: {
    chartType: {
      type: String
    },
    barThicknessChart: {
      type: Number
    },
    barLenghtChart: {
      type: Number
    },
    stepSizeBarX: {
      type: String
    },
    stepSizeBarY: {
      type: String
    },
    dataBarChart: {
      type: Array
    },
    isAxeHidden: {
      type: Boolean
    },
    titleBarChart: {
      type: String
    },
    isTitledisplayed: {
      type: Boolean
    },
    areGridsHidden: {
      type: Boolean
    }
  },
  data () {
    return {
      barChart: null
    }
  },
  watch: {
    dataBarChart (dataChart) {
      this.barChart.data.labels = this.handleGetDataChart(dataChart, 'damage_subtype')
      this.barChart.data.datasets.forEach((dataset) => {
        dataset.data = this.handleGetDataChart(dataChart, 'amount')
      })
      this.barChart.update()
    }
  },
  methods: {
    handleGetDataChart (arrData, elem) {
      let arrDataItems = arrData.map(item => {
        return item[elem]
      })
      return arrDataItems
    },

    handleCreateBarChart (dataChart) {
      this.barChart = new Chart(this.$el, {
        type: 'pie',
        data: {
          labels: this.handleGetDataChart(dataChart, 'damage_subtype'),
          datasets: [{
            backgroundColor: [
              '#2ecc71',
              '#3498db',
              '#95a5a6',
              '#9b59b6',
              '#f1c40f',
              '#e74c3c',
              '#34495e',
              '#2ecc71',
              '#3498db',
              '#95a5a6',
              '#9b59b6',
              '#f1c40f',
              '#e74c3c',
              '#34495e',
              '#3498db',
              '#95a5a6',
              '#9b59b6',
              '#f1c40f',
              '#e74c3c',
              '#34495e'
            ],
            label: 'pie',

            data: this.handleGetDataChart(dataChart, 'amount')
          }]
        },
        options: {
          legend: {
            position: 'right'
          },
          responsive: true,
          aspectRatio: 4
        }
      })
    }
  },
  mounted () {
    this.handleCreateBarChart(this.dataBarChart)
  }
}
